import { render, staticRenderFns } from "./perMsgDialog.vue?vue&type=template&id=5e69c9a8&scoped=true"
import script from "./perMsgDialog.vue?vue&type=script&lang=js"
export * from "./perMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./perMsgDialog.vue?vue&type=style&index=0&id=5e69c9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e69c9a8",
  null
  
)

export default component.exports